// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7sonT","links":"Footer_links__c2Dwj","separator":"Footer_separator__0j1f7","copyrightNotice":"Footer_copyrightNotice__YGWB1"};